import { MOVE_INGREDIENT_BETWEEN_AISLES_IN_GROCERY_LIST } from "./actionTypes";

export default (fromGroupId, toGroupId) => ({
  type: MOVE_INGREDIENT_BETWEEN_AISLES_IN_GROCERY_LIST,
  payload: {
    fromGroupId,
    toGroupId
  }
});